//  export const ApiConnectionString = "https://localhost:7094"



  export const ApiConnectionString = "https://bcsoftwareapi-hxeqbcbkh8gwhjdv.ukwest-01.azurewebsites.net"




